import { render, staticRenderFns } from "./BankCardEquip.vue?vue&type=template&id=52aa07e6&scoped=true"
import script from "./BankCardEquip.vue?vue&type=script&lang=js"
export * from "./BankCardEquip.vue?vue&type=script&lang=js"
import style0 from "./BankCardEquip.vue?vue&type=style&index=0&id=52aa07e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aa07e6",
  null
  
)

export default component.exports